/* ═══════════════════════════════════════════════════════════════════
   HEADER TABLĂ-ONLINE — interacțiuni (portat din main.js al site-ului static)
   • sticky shrink la scroll
   • drawer mobil (hamburger + overlay + Escape)
   • cart count live: evenimentul `cart:update` al temei Horizon + fallback /cart.js
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  function initHeader(root) {
    const header = root.querySelector("[data-header]");
    const hamburger = root.querySelector("[data-hamburger]");
    const drawer = root.querySelector("[data-drawer]");
    const overlay = root.querySelector("[data-overlay]");

    /* ---------- Sticky ----------
       Un element sticky poate „aluneca" doar în interiorul părintelui său. În Horizon,
       secțiunile de header stau în <div id="header-group"> care e exact cât conținutul —
       sticky pe .shopify-section n-are travel. Facem sticky chiar #header-group (părintele
       lui e <body>, înalt cât pagina). Pe alte teme, fallback: sticky pe .shopify-section. */
    const section = root.closest(".shopify-section");
    if (section) section.classList.add("to-header-section");
    const group = root.closest("#header-group");
    if (group) {
      group.classList.add("to-header-sticky-group");
      /* Topbar-ul (și orice altceva de deasupra header-ului alb) NU rămâne sticky:
         grupul stă cu `top` negativ exact cât distanța până la header, astfel încât
         la scroll topbar-ul alunecă în afara ecranului iar header-ul + navbar rămân. */
      const updateStickyOffset = () => {
        if (!header) return;
        const off = header.getBoundingClientRect().top - group.getBoundingClientRect().top;
        group.style.top = `-${Math.max(0, Math.round(off))}px`;
      };
      updateStickyOffset();
      window.addEventListener("resize", updateStickyOffset);
      window.addEventListener("load", updateStickyOffset);
    }

    /* ---------- Portal: mută drawer-ul și overlay-ul direct în <body>.
       Horizon aplică transformări pe wrapper-ele secțiunilor, iar position:fixed
       dintr-un ancestor transformat se raportează la acesta, nu la viewport —
       drawer-ul ar rămâne vizibil în mijlocul paginii. ---------- */
    if (drawer) document.body.appendChild(drawer);
    if (overlay) document.body.appendChild(overlay);

    /* ---------- Căutare predictivă (live) ---------- */
    function setupSearch(form, resultsEl, isPop) {
      if (!form || !resultsEl) return;
      const input = form.querySelector('input[name="q"], input[type="search"]');
      if (!input) return;
      let timer = null, lastQ = "", ctrl = null;

      const hide = () => { resultsEl.hidden = true; resultsEl.innerHTML = ""; };
      const esc = (s) => (s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

      /* /search/suggest.json întoarce prețul ca STRING deja în lei ("41.00"), nu în bani —
         împărțirea la 100 afișa „0,41 lei". Acceptăm și number (bani), pentru cazul în care
         funcția ar fi hrănită din alt API (cart.js, product.json), unde prețul chiar e în bani. */
      const fmtPrice = (v) => {
        if (v == null || v === "") return "";
        const n = typeof v === "number" ? v / 100 : parseFloat(String(v).replace(/[^\d.,-]/g, "").replace(",", "."));
        if (!isFinite(n)) return "";
        return n.toFixed(2).replace(".", ",") + " lei";
      };

      const render = (products, q) => {
        if (!products.length) {
          resultsEl.innerHTML = '<div class="srch-empty">Niciun rezultat pentru „' + esc(q) + "”</div>";
          resultsEl.hidden = false;
          return;
        }
        let html = "";
        products.forEach((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || "");
          const price = fmtPrice(p.price);
          html +=
            '<a class="srch-item" href="' + esc(p.url) + '">' +
            (img ? '<img class="srch-item__img" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="srch-item__img"></span>') +
            '<span class="srch-item__body"><span class="srch-item__title">' + esc(p.title) + "</span>" +
            (price ? '<span class="srch-item__price">' + price + "</span>" : "") +
            "</span></a>";
        });
        html += '<a class="srch-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Vezi toate rezultatele →</a>';
        resultsEl.innerHTML = html;
        resultsEl.hidden = false;
      };

      const query = (q) => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last", { signal: ctrl.signal })
          .then((r) => r.json())
          .then((data) => {
            const products = (((data.resources || {}).results || {}).products) || [];
            if (input.value.trim() === q) render(products, q);
          })
          .catch(() => {});
      };

      input.addEventListener("input", () => {
        const q = input.value.trim();
        if (timer) clearTimeout(timer);
        if (q.length < 2) { lastQ = ""; hide(); return; }
        if (q === lastQ) return;
        lastQ = q;
        timer = setTimeout(() => query(q), 220);
      });
      input.addEventListener("focus", () => { if (resultsEl.innerHTML && input.value.trim().length >= 2) resultsEl.hidden = false; });
      if (isPop) {
        document.addEventListener("click", (e) => { if (!form.parentNode.contains(e.target)) hide(); });
        input.addEventListener("keydown", (e) => { if (e.key === "Escape") hide(); });
      }
    }
    root.querySelectorAll("[data-search-box]").forEach((box) => {
      setupSearch(box.querySelector("form"), box.querySelector("[data-search-results]"), true);
    });
    if (drawer) {
      const dForm = drawer.querySelector(".drawer__search");
      setupSearch(dForm, drawer.querySelector("[data-search-results]"), false);
    }

    /* ---------- Placeholder „typewriter" pe căutare ----------
       „Caută țiglă metalică…" → categoria se șterge literă cu literă și se tastează următoarea.
       Fără librărie: animăm ATRIBUTUL placeholder (Typed.js & co. animează noduri de text,
       nu atribute — tot manual am scrie logica), deci zero dependențe, zero layout shift,
       iar fallback-ul e chiar placeholder-ul static din markup, dacă JS nu rulează.
       Fiabilitate: pauză cât inputul e focusat/are text (placeholderul oricum nu se vede și
       nu distragem în timp ce omul scrie), pauză când tab-ul e în fundal (altfel browserul
       throttluie timerele și animația „sare"), oprită complet la prefers-reduced-motion.
       aria-label rămâne static — cititoarele de ecran nu aud fiecare literă. */
    function setupPlaceholderTypewriter() {
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      const inputs = [];
      root.querySelectorAll(".hsearch__input").forEach((i) => inputs.push(i));
      if (drawer) { const di = drawer.querySelector("[data-drawer-search]"); if (di) inputs.push(di); }
      if (!inputs.length) return;
      if (inputs[0].dataset.twInit) return; /* editorul de teme re-inițializează secțiunea */
      inputs.forEach((i) => { i.dataset.twInit = "1"; });

      const PREFIX = "Caută ";
      /* colecțiile importante, nu toate — sincron cu mega-meniul.
         WORDS[0] TREBUIE să coincidă cu placeholderul static din markup („Caută țiglă
         metalică…"): animația pornește cu el deja scris și începe prin a-l ține pe ecran,
         apoi îl șterge — fără niciun salt vizibil la preluarea controlului de către JS. */
      const WORDS = ["țiglă metalică", "tablă cutată", "șipcă de gard", "sisteme pluviale", "ferestre de mansardă", "accesorii montaj"];
      let wi = 0, text = WORDS[0], deleting = false, timer = null;

      const idle = () => inputs.every((i) => document.activeElement !== i && !i.value);
      const apply = () => {
        const ph = PREFIX + text + (deleting ? "" : "…");
        inputs.forEach((i) => { if (document.activeElement !== i && !i.value) i.placeholder = ph; });
      };
      const step = () => {
        /* focus sau text în input → stăm deoparte și reverificăm din când în când */
        if (!idle() || document.hidden) { timer = setTimeout(step, 1200); return; }
        const word = WORDS[wi % WORDS.length];
        let delay;
        if (!deleting) {
          text = word.slice(0, text.length + 1);
          apply();
          if (text === word) { deleting = true; delay = 2200; }        /* cuvânt complet → pauză de citit */
          else delay = 65 + Math.random() * 55;                        /* tastare, cu mici variații umane */
        } else {
          text = text.slice(0, -1);
          apply();
          if (!text) { deleting = false; wi++; delay = 450; }          /* șters tot → următoarea categorie */
          else delay = 32;                                             /* ștersul e mai rapid decât scrisul */
        }
        timer = setTimeout(step, delay);
      };
      /* la focus punem placeholderul complet, static — fără animație sub cursor */
      inputs.forEach((i) => i.addEventListener("focus", () => { i.placeholder = "Caută produse…"; }));
      document.addEventListener("visibilitychange", () => {
        if (document.hidden && timer) { clearTimeout(timer); timer = setTimeout(step, 300); }
      });
      timer = setTimeout(step, 1400); /* mic răgaz după încărcare, nu concurăm cu LCP */
    }
    setupPlaceholderTypewriter();

    /* ---------- Header sticky shrink ---------- */
    const onScroll = () => header && header.classList.toggle("is-scrolled", window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    /* ---------- Mobile drawer ---------- */
    /* Drawer-ul e un dialog modal (role="dialog" aria-modal="true" în markup): cât e deschis,
       focusul trebuie să stea înăuntru, iar la închidere să se întoarcă de unde a plecat. */
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
    let lastFocused = null;

    const setMenu = (open) => {
      if (!hamburger || !drawer || !overlay) return;
      const wasOpen = drawer.classList.contains("is-open");
      hamburger.classList.toggle("is-open", open);
      drawer.classList.toggle("is-open", open);
      overlay.classList.toggle("is-open", open);
      hamburger.setAttribute("aria-expanded", String(open));
      /* eticheta descrie ACȚIUNEA butonului, deci se schimbă odată cu starea */
      hamburger.setAttribute("aria-label", open ? "Închide meniul" : "Deschide meniul");
      drawer.setAttribute("aria-hidden", String(!open));
      document.body.style.overflow = open ? "hidden" : "";

      if (open && !wasOpen) {
        lastFocused = document.activeElement;
        /* `visibility` se transformă în `visible` abia după începerea tranziției —
           un focus() sincron pe un element încă invizibil ar fi ignorat de browser. */
        const first = drawer.querySelector("[data-drawer-close]") || drawer.querySelector(FOCUSABLE);
        if (first) setTimeout(() => first.focus(), 50);
      } else if (!open && wasOpen) {
        if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
        lastFocused = null;
      }
    };
    if (hamburger) hamburger.addEventListener("click", () => setMenu(!drawer.classList.contains("is-open")));
    if (overlay) overlay.addEventListener("click", () => setMenu(false));
    if (drawer) drawer.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => setMenu(false)));
    if (drawer) {
      const closeBtn = drawer.querySelector("[data-drawer-close]");
      if (closeBtn) closeBtn.addEventListener("click", () => setMenu(false));

      /* capcană de focus: Tab/Shift+Tab circulă doar prin elementele vizibile din drawer
         (cele din <details> închise au offsetParent null, deci sunt sărite) */
      drawer.addEventListener("keydown", (e) => {
        if (e.key !== "Tab" || !drawer.classList.contains("is-open")) return;
        const items = [].filter.call(drawer.querySelectorAll(FOCUSABLE), (el) => el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    /* Escape închide DOAR dacă drawer-ul e deschis — altfel am reseta body.overflow
       setat de altă componentă (drawer-ul de coș Horizon) la orice apăsare de Escape. */
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) setMenu(false);
    });

    /* ---------- Lupă (mobil): deschide drawer-ul și focus pe căutare ---------- */
    const searchOpen = root.querySelector("[data-search-open]");
    if (searchOpen) {
      searchOpen.addEventListener("click", () => {
        setMenu(true);
        const inp = document.querySelector("[data-drawer-search]");
        if (inp) setTimeout(() => inp.focus(), 320);
      });
    }

    /* ---------- Bară anunțuri: rotește mesajele (fade), la interval configurabil ---------- */
    const announce = root.querySelector("[data-announce]");
    if (announce) {
      const msgs = announce.querySelectorAll(".announce__msg");
      if (msgs.length > 1) {
        let idx = Math.max(0, [].findIndex.call(msgs, (m) => m.classList.contains("is-active")));
        const ms = (parseFloat(announce.dataset.interval) || 5) * 1000;
        setInterval(() => {
          msgs[idx].classList.remove("is-active");
          idx = (idx + 1) % msgs.length;
          msgs[idx].classList.add("is-active");
        }, ms);
      }
    }

    /* ---------- Megamenu: comutare taburi (L2) → panouri (L3) ---------- */
    root.querySelectorAll("[data-mega]").forEach((item) => {
      const tabs = item.querySelectorAll("[data-mega-tab]");
      const panes = item.querySelectorAll("[data-mega-pane]");
      const activate = (idx) => {
        tabs.forEach((t) => t.classList.toggle("is-active", t.dataset.megaTab === String(idx)));
        panes.forEach((p) => p.classList.toggle("is-active", p.dataset.megaPane === String(idx)));
      };
      tabs.forEach((t) => {
        /* hover + focus = comută panoul (UX clasic de megamenu).
           Clickul NU mai e interceptat: categoriile sunt linkuri către colecția-umbrelă. */
        t.addEventListener("mouseenter", () => activate(t.dataset.megaTab));
        t.addEventListener("focus", () => activate(t.dataset.megaTab));
      });
      /* la fiecare deschidere, resetează pe primul tab */
      const trigger = item.querySelector("[data-mega-trigger]");
      if (trigger) item.addEventListener("mouseenter", () => activate(0));
    });

    /* ---------- Cart count ---------- */
    const counts = root.querySelectorAll(".js-cart-count");
    const setCount = (n) => {
      if (n == null || isNaN(n)) return;
      counts.forEach((el) => {
        if (el.textContent === String(n)) return;
        el.textContent = n;
        if (el.animate) {
          el.animate(
            [{ transform: "scale(1)" }, { transform: "scale(1.4)" }, { transform: "scale(1)" }],
            { duration: 300, easing: "ease-out" }
          );
        }
      });
    };

    const refreshCount = () => {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then((r) => r.json())
        .then((cart) => setCount(cart.item_count))
        .catch(() => {});
    };

    /* Horizon publică `cart:update` pe document (CartUpdateEvent) la orice modificare
       de coș (add/remove/qty). Citim count-ul din detail dacă există, altfel refetch. */
    document.addEventListener("cart:update", (e) => {
      const d = (e && e.detail) || {};
      const n =
        (d.resource && d.resource.item_count) ??
        (d.data && d.data.itemCount) ??
        d.itemCount;
      if (n != null) setCount(parseInt(n, 10));
      else refreshCount();
    });

    /* bfcache (back din checkout/cart) — recitește count-ul */
    window.addEventListener("pageshow", (e) => { if (e.persisted) refreshCount(); });
  }

  const boot = () => {
    /* curăță drawerele/overlay-urile portalate de o inițializare anterioară
       (editorul de teme re-randează secțiunea fără reload de pagină) */
    document.querySelectorAll("body > .to-header-drawer, body > .to-header-overlay")
      .forEach((el) => { if (!el.closest("[data-to-header]")) el.remove(); });
    document.querySelectorAll("[data-to-header]").forEach(initHeader);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  /* editorul de teme: re-inițializează la reload-ul secțiunii */
  document.addEventListener("shopify:section:load", boot);
})();
